export default {
    meta: {
        title: '拓店宝-地图定位页'
    }
};
